export default (url, user) => {

	const ws = new WebSocket(url)

	ws.msgEvents = {}

	ws.addEventListener('message', ev => {

		const { canal, msg, user } = JSON.parse(ev.data)

		if (!ws.msgEvents[canal] || ws.msgEvents[canal].length === 0) {

			console.log('Recibido canal incompatible: ' + canal)

			return

		}

		ws.msgEvents[canal].forEach(m => m(msg, user))

	})

	ws.onMsg = function (canal, callback) {

		if (!ws.msgEvents[canal]) ws.msgEvents[canal] = []

		ws.msgEvents[canal].push(callback)

	}

	ws.delMsg = function (canal, callback) {

		if (!ws.msgEvents[canal]) return

		const index = ws.msgEvents[canal].findIndex(m => m === callback)

		ws.msgEvents[canal].splice(index, 1)

	}

	ws.sendMsg = function (canal, msg) {

		ws.send(JSON.stringify({
			canal,
			msg
		}))

	}

	ws.addEventListener('open', () => { ws.sendMsg('login', user) })
	ws.addEventListener('error', () => { location.reload() })
	ws.addEventListener('close', () => { location.reload() })

	return ws

}
